import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-118">
      <FadeIn data-id="element-119">
        <div className="bg-[#0a0a0a] rounded-[2.5rem] p-8 md:p-16 border border-[#c9a961]/30 shadow-[0_20px_50px_rgba(10,10,10,0.15)] relative overflow-hidden" data-id="element-120">
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#c9a961_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-121"></div>

          <div className="relative z-10" data-id="element-122">
            <h2 className="md:text-5xl font-black mb-10 text-transparent bg-clip-text bg-gradient-to-r from-white to-[#e8dfd0] text-[28px]" data-id="element-123">
              El próximo domingo puede ser diferente. 🤖
            </h2>

            <div className="space-y-6 max-w-2xl mx-auto mb-10" data-id="element-124">
              {/* Option 1 */}
              <a href="https://tumanualdigital.com/cart/44175053488164:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-[#1a1611] border border-[#c9a961]/30 rounded-2xl hover:border-[#c9a961] transition-colors group pt-[0px] pb-[0px]" data-id="element-125">
                <div className="text-left mb-4 sm:mb-0" data-id="element-126">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-127">
                    <span data-id="element-128">📘</span> MEGAPACK BÁSICO
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-129">
                    <span className="text-[#b91c1c] line-through text-sm font-bold" data-id="element-130">
                      $95.000
                    </span>
                    <span className="text-2xl font-black text-white" data-id="element-131">
                      $19.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#2a241c] text-[#c9a961] font-black py-3 px-6 rounded-xl group-hover:bg-[#3a3226] transition-colors w-full sm:w-auto text-center border border-[#c9a961]/30" data-id="element-132">
                  → QUIERO MI MEGAPACK
                </div>
              </a>

              {/* Option 2 */}
              <a href="https://tumanualdigital.com/cart/44175081799716:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-[#c9a961]/20 to-[#1a1611] border-2 border-[#c9a961] rounded-2xl hover:shadow-[0_0_30px_rgba(201,169,97,0.3)] transition-all group relative overflow-hidden" data-id="element-133">
                <div className="absolute top-0 right-0 bg-[#c9a961] text-[#0a0a0a] text-xs font-black px-3 py-1 rounded-bl-lg" data-id="element-134">
                  ⭐ MÁS ELEGIDO
                </div>
                <div className="text-left mb-4 sm:mb-0 mt-2 sm:mt-0" data-id="element-135">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-136">
                    <span data-id="element-137">🏆</span> MEGAPACK + MÁQUINA
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-138">
                    <span className="text-[#b91c1c] line-through text-sm font-bold" data-id="element-139">
                      $130.000
                    </span>
                    <span className="text-2xl font-black text-[#c9a961]" data-id="element-140">
                      $27.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#c9a961] text-[#0a0a0a] font-black py-3 px-6 rounded-xl group-hover:bg-[#d4af37] transition-colors w-full sm:w-auto text-center shadow-lg" data-id="element-141">
                  → QUIERO EL MEGAPACK + MÁQUINA ADMINISTRATIVA
                </div>
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-[#e8dfd0] font-bold" data-id="element-142">
              <span className="flex items-center gap-1.5" data-id="element-143">
                <Lock size={16} className="text-[#c9a961]" data-id="element-144" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-145">
                <Zap size={16} className="text-[#c9a961]" data-id="element-146" /> Acceso en 5 min
              </span>
              <span className="flex items-center gap-1.5" data-id="element-147">
                <Shield size={16} className="text-[#c9a961]" data-id="element-148" /> Garantía 7 días
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-x-4 mt-4 text-sm text-[#6b5d4f] font-medium" data-id="element-149">
              <span className="flex items-center gap-1.5" data-id="element-150">
                <CreditCard size={16} data-id="element-151" /> Mercado Pago · Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}